import { ReactNode } from 'react';
import clsx from 'clsx';

interface H2HeadingProps {
  children: ReactNode;
  className?: string;
  noMarginBottom?: boolean;
  smallerDesktopFont?: boolean;
}

const H2Heading = ({
  children,
  className,
  noMarginBottom = false,
  smallerDesktopFont,
}: H2HeadingProps) => {
  return (
    <h2
      className={clsx(
        'text-[2.4rem] leading-[3rem] md:text-[2.6rem] md:leading-[3.2rem] font-medium [&_strong]:font-[850] text-primary',
        { 'mb-0': noMarginBottom },
        { 'mb-[2rem] md:mb-[1.5rem]': !noMarginBottom },
        { 'xlup:text-[2.6rem] xlup:leading-[3.2rem]': smallerDesktopFont },
        { 'xlup:text-[3rem] xlup:leading-[3.6rem]': !smallerDesktopFont },
        className,
      )}>
      {children}
    </h2>
  );
};

export default H2Heading;
